import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/fonts.css';
import 'aos/dist/aos.css';

export const shouldUpdateScroll = ({ routerProps }) => {
  return false;
};
